
export const API_ERROR_TYPE  = 'CommandException'
export const MODULE_KEY  = 'file-module'
export enum FileType {
    doc = 'doc',
    docx = 'docx',
    csv = 'csv',
    xls = 'xls',
    xlsx = 'xlsx',
    ppt = 'ppt',
    pptx = 'pptx',
    pdf = 'pdf',
    png = 'png',
    jpg = 'jpg',
    jpeg = 'jpeg'
}

export const ListFileType = [
    {
        value: FileType.doc,
        displayValue: 'doc'
    },
    {
        value: FileType.docx,
        displayValue: 'docx'
    },
    {
        value: FileType.csv,
        displayValue: 'csv'
    },
    {
        value: FileType.xls,
        displayValue: 'xls'
    },
    {
        value: FileType.xlsx,
        displayValue: 'xlsx'
    },
    {
        value: FileType.ppt,
        displayValue: 'ppt'
    },
    {
        value: FileType.pptx,
        displayValue: 'pptx'
    },
    {
        value: FileType.pdf,
        displayValue: 'pdf'
    },
    {
        value: FileType.png,
        displayValue: 'png'
    },
    {
        value: FileType.jpg,
        displayValue: 'jpg'
    },
    {
        value: FileType.jpeg,
        displayValue: 'jpeg'
    },
];

export const GENERATE_DOCUMENT_STATUS = {
  COMPLETED: 'Completed'
}

export enum ParticipantDocumentType {
  DeathCertificate,
  MarriedCertificate,
  InvoiceVoucher,
  Other,
  AnnualPensionCertification = 4,
  BirthCertificate,
  DocumentaryEvidence,
  HistoricalScannedRemittance,
  MarriageCertificate,
  MedicalRecords,
  QdroForms,
  QdroDocuments,
  Retire_RehireForm,
  ScannedRetirementForms,
}

export enum ParticipantGenerateDocumentType {
  NoticeofRetirement  = 1000,
  Age65Letter = 1001,
  PensionCertificationReport= 1002,
  CurrentAFRSDisbursementReport= 1003,
  PensionConfirmationLetter = 1004,
}

export enum EmployerDocumentType {
  Other = 10000,
  CertificationForm= 10001,
  Retire_RehireForm = 10002,
  InvoiceVoucher = 10003,
}

export const PARTICIPANT_DOCUMENT_TYPE_OPTIONS = [
    {
        value: ParticipantDocumentType.DeathCertificate,
        displayValue: 'Death Certificate'
    },
    {
        value: ParticipantDocumentType.MarriedCertificate,
        displayValue: 'Married Certificate'
    },
    {
        value: ParticipantDocumentType.InvoiceVoucher,
        displayValue: 'Invoice Voucher'
    },
    {
        value: ParticipantDocumentType.Other,
        displayValue: 'Other'
    },
];

export const PARTICIPANT_DOCUMENT_TYPE_OPTIONS_FOR_BVFF = [
  {
    value: ParticipantDocumentType.BirthCertificate,
    displayValue: 'Birth Certificate'
  },
  {
    value: ParticipantDocumentType.DeathCertificate,
    displayValue: 'Death Certificate'
  },
  {
    value: ParticipantDocumentType.DocumentaryEvidence,
    displayValue: 'Documentary Evidence'
  },
  {
    value: ParticipantDocumentType.InvoiceVoucher,
    displayValue: 'Invoice Voucher'
  },
  {
    value: ParticipantDocumentType.MarriageCertificate,
    displayValue: 'Marriage Certificate'
  },
  {
    value: ParticipantDocumentType.MedicalRecords,
    displayValue: 'Medical Records'
  },
  {
    value: ParticipantDocumentType.QdroDocuments,
    displayValue: 'QDRO Documents'
  },
  {
    value: ParticipantDocumentType.Other,
    displayValue: 'Other'
  },
];

export const EMPLOYER_DOCUMENT_TYPE_OPTIONS = [
  {
    value: EmployerDocumentType.CertificationForm,
    displayValue: 'Certification Form'
  },
  {
    value: EmployerDocumentType.InvoiceVoucher,
    displayValue: 'Invoice Voucher'
  },
  {
    value: EmployerDocumentType.Retire_RehireForm,
    displayValue: 'Retire/Rehire Form'
  },
  {
    value: EmployerDocumentType.Other,
    displayValue: 'Other'
  },
];
